// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_MutableQueue = require("rescript/lib/js/belt_MutableQueue.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function ptGetFrms(tree) {
  return tree.frms;
}

function ptGetParenCnt(tree) {
  return tree.parenCnt;
}

function ptIsDisj(tree, n, m) {
  return MM_context.disjContains(tree.disj, n, m);
}

function ptIsNewVarDef(tree, expr) {
  return Belt_HashSet.has(tree.newVars, expr);
}

function ptMake(frms, hyps, ctxMaxVar, disj, parenCnt, exprToStr) {
  return {
          frms: frms,
          hypsByExpr: Belt_HashMap.fromArray(Belt_MapString.toArray(hyps).map(function (param) {
                    var hyp = param[1];
                    return [
                            hyp.expr,
                            hyp
                          ];
                  }), MM_context.ExprHash),
          hypsByLabel: Belt_HashMapString.fromArray(Belt_MapString.toArray(hyps)),
          ctxMaxVar: ctxMaxVar,
          maxVar: ctxMaxVar,
          newVars: Belt_HashSet.make(16, MM_context.ExprHash),
          dbgNewVars: [],
          disj: disj,
          dbgDisj: [],
          parenCnt: parenCnt,
          nodes: Belt_HashMap.make(16, MM_context.ExprHash),
          rootStmts: [],
          exprToStr: exprToStr
        };
}

function ptGetHypByExpr(tree, expr) {
  return Belt_HashMap.get(tree.hypsByExpr, expr);
}

function ptGetHypByLabel(tree, label) {
  return Belt_HashMapString.get(tree.hypsByLabel, label);
}

function ptGetMaxVar(tree) {
  return tree.maxVar;
}

function ptGetCtxMaxVar(tree) {
  return tree.ctxMaxVar;
}

function proofNodeGetExprStr(node) {
  var str = node.exprStr;
  if (str !== undefined) {
    return str;
  } else {
    return node.expr.map(function (prim) {
                  return String(prim);
                }).join(" ");
  }
}

function ptGetNuberOfNodes(tree) {
  return Belt_HashMap.size(tree.nodes);
}

function ptGetStats(tree) {
  Belt_HashMap.getBucketHistogram(tree.nodes);
}

function ptGetRootStmts(tree) {
  return tree.rootStmts;
}

function ptGetNodeByExpr(tree, expr) {
  return Belt_HashMap.get(tree.nodes, expr);
}

function ptGetOrCreateNode(tree, expr) {
  var node = Belt_HashMap.get(tree.nodes, expr);
  if (node !== undefined) {
    return node;
  } else {
    var existingNode = Belt_HashMap.get(tree.nodes, expr);
    if (existingNode !== undefined) {
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Creation of a new node was requested, " + ("but a node with the same expression already exists '" + proofNodeGetExprStr(existingNode) + "'.")
            },
            Error: new Error()
          };
    }
    var node$1 = {
      expr: expr,
      exprStr: Belt_Option.map(tree.exprToStr, (function (f) {
              return Curry._1(f, expr);
            })),
      parents: undefined,
      children: [],
      proof: undefined,
      isInvalidFloating: false,
      dist: undefined
    };
    Belt_HashMap.set(tree.nodes, expr, node$1);
    return node$1;
  }
}

function ptAddRootStmt(tree, stmt) {
  var match = tree.rootStmts.find(function (existingStmt) {
        return MM_context.exprEq(existingStmt.expr, stmt.expr);
      });
  if (match !== undefined) {
    return ;
  } else {
    tree.rootStmts.push(stmt);
    return ;
  }
}

function ptClearDists(tree) {
  Belt_HashMap.forEach(tree.nodes, (function (param, node) {
          node.dist = undefined;
        }));
}

function esIsProved(exprSrc) {
  if (typeof exprSrc === "number" || exprSrc.TAG === /* Hypothesis */0) {
    return true;
  } else {
    return exprSrc.args.every(function (arg) {
                return Belt_Option.isSome(arg.proof);
              });
  }
}

function pnGetProofFromParents(node) {
  var parents = node.parents;
  if (parents !== undefined) {
    return Caml_option.undefined_to_opt(parents.find(esIsProved));
  }
  
}

function pnGetExpr(node) {
  return node.expr;
}

function pnGetExprStr(node) {
  return node.exprStr;
}

function pnGetProof(node) {
  return node.proof;
}

function pnGetParents(node) {
  return node.parents;
}

function pnAddParent(node, parent) {
  var match = node.proof;
  if (match !== undefined) {
    return ;
  }
  var newParentWasAdded = false;
  var parents = node.parents;
  if (parents !== undefined) {
    var existingParent = parents.find(function (par) {
          if (typeof par === "number") {
            if (typeof parent === "number") {
              return true;
            } else {
              return false;
            }
          }
          if (par.TAG === /* Hypothesis */0) {
            if (typeof parent === "number" || parent.TAG !== /* Hypothesis */0) {
              return false;
            } else {
              return par.label === parent.label;
            }
          }
          var args1 = par.args;
          if (typeof parent === "number") {
            return false;
          }
          if (parent.TAG === /* Hypothesis */0) {
            return false;
          }
          var args2 = parent.args;
          if (par.label === parent.label && args1.length === args2.length) {
            return args1.every(function (arg1, idx) {
                        return MM_context.exprEq(arg1.expr, Caml_array.get(args2, idx).expr);
                      });
          } else {
            return false;
          }
        });
    if (existingParent !== undefined) {
      if (esIsProved(existingParent)) {
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Unexpected: an unproved node '" + proofNodeGetExprStr(node) + "' has a proved parent."
              },
              Error: new Error()
            };
      }
      
    } else {
      parents.push(parent);
      newParentWasAdded = true;
    }
  } else {
    node.parents = [parent];
    newParentWasAdded = true;
  }
  if (!newParentWasAdded) {
    return ;
  }
  if (typeof parent !== "number" && parent.TAG !== /* Hypothesis */0) {
    parent.args.forEach(function (__x) {
          if (MM_context.exprEq(__x.expr, node.expr)) {
            return ;
          }
          var match = __x.children.find(function (existingChild) {
                return MM_context.exprEq(existingChild.expr, node.expr);
              });
          if (match !== undefined) {
            return ;
          } else {
            __x.children.push(node);
            return ;
          }
        });
  }
  if (esIsProved(parent)) {
    var match$1 = node.proof;
    if (match$1 !== undefined) {
      return ;
    }
    var nodeProof = pnGetProofFromParents(node);
    if (nodeProof === undefined) {
      return ;
    }
    node.proof = nodeProof;
    var nodesToMarkProved = Belt_MutableQueue.fromArray(node.children);
    while(!Belt_MutableQueue.isEmpty(nodesToMarkProved)) {
      var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToMarkProved));
      if (Belt_Option.isNone(curNode.proof)) {
        var curNodeProof = pnGetProofFromParents(curNode);
        if (curNodeProof !== undefined) {
          curNode.proof = curNodeProof;
          curNode.children.forEach(function (param) {
                return Belt_MutableQueue.add(nodesToMarkProved, param);
              });
        }
        
      }
      
    };
    return ;
  }
  
}

function pnSetInvalidFloating(node, isInvalidFloating) {
  node.isInvalidFloating = isInvalidFloating;
}

function pnGetDist(node) {
  return node.dist;
}

function pnSetDist(node, dist) {
  node.dist = dist;
}

function pnIsInvalidFloating(node) {
  return node.isInvalidFloating;
}

function ptAddNewVar(tree, typ) {
  tree.maxVar = tree.maxVar + 1 | 0;
  var newVar = tree.maxVar;
  Belt_HashSet.add(tree.newVars, [
        typ,
        newVar
      ]);
  var exprToStr = tree.exprToStr;
  if (exprToStr !== undefined) {
    tree.dbgNewVars.push(Curry._1(exprToStr, [
              typ,
              newVar
            ]));
  }
  return newVar;
}

function ptAddDisjPair(tree, n, m) {
  MM_context.disjAddPair(tree.disj, n, m);
  var exprToStr = tree.exprToStr;
  if (exprToStr !== undefined) {
    tree.dbgDisj.push(Curry._1(exprToStr, [
              n,
              m
            ]));
    return ;
  }
  
}

function ptGetCopyOfNewVars(tree) {
  return Belt_HashSet.toArray(tree.newVars);
}

function ptGetCopyOfDisj(tree) {
  var disj = MM_context.disjMutableMake(undefined);
  MM_context.disjForEach(tree.disj, (function (param, param$1) {
          return MM_context.disjAddPair(disj, param, param$1);
        }));
  return disj;
}

function ptGetExprToStr(tree) {
  return tree.exprToStr;
}

exports.ptMake = ptMake;
exports.ptGetFrms = ptGetFrms;
exports.ptGetHypByExpr = ptGetHypByExpr;
exports.ptGetHypByLabel = ptGetHypByLabel;
exports.ptGetMaxVar = ptGetMaxVar;
exports.ptGetCtxMaxVar = ptGetCtxMaxVar;
exports.ptGetParenCnt = ptGetParenCnt;
exports.ptIsDisj = ptIsDisj;
exports.ptIsNewVarDef = ptIsNewVarDef;
exports.ptGetRootStmts = ptGetRootStmts;
exports.ptGetNodeByExpr = ptGetNodeByExpr;
exports.ptGetOrCreateNode = ptGetOrCreateNode;
exports.ptAddNewVar = ptAddNewVar;
exports.ptAddDisjPair = ptAddDisjPair;
exports.ptGetCopyOfNewVars = ptGetCopyOfNewVars;
exports.ptGetCopyOfDisj = ptGetCopyOfDisj;
exports.ptGetExprToStr = ptGetExprToStr;
exports.ptAddRootStmt = ptAddRootStmt;
exports.ptClearDists = ptClearDists;
exports.ptGetNuberOfNodes = ptGetNuberOfNodes;
exports.ptGetStats = ptGetStats;
exports.pnGetExpr = pnGetExpr;
exports.pnGetExprStr = pnGetExprStr;
exports.pnGetProof = pnGetProof;
exports.pnGetParents = pnGetParents;
exports.pnAddParent = pnAddParent;
exports.pnIsInvalidFloating = pnIsInvalidFloating;
exports.pnSetInvalidFloating = pnSetInvalidFloating;
exports.pnGetDist = pnGetDist;
exports.pnSetDist = pnSetDist;
/* MM_context Not a pure module */
